/*=============================================== FullBleedPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { paddingObject } from "data"

const FullBleedPage = () => {
    const items: ItemType[] = [
        {
            content: (
                <Text>
                    <Link
                        to="/layouts/container/demo-main-full"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<FullBleed padding={{ leftRight: "xxl" }} height={400} as="section">\n    \n</FullBleed>\n',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "height",
            type: "string or number",
        },
        {
            subtitle: "aspectRatio",
            type: "string",
        },
        ...paddingObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default FullBleedPage
